import { Component, inject, OnInit } from '@angular/core'
import { Table } from '@ui/Table'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { ConfirmDeleteDialogComponent } from '@account/Dialogs/ConfirmDeleteDialog.Component'
import HttpError from '@ui/HttpError'
import Address, { BILLING } from '@account/Address'
import { AddressService } from '@account/Services/AddressService'
import { PageComponent } from '@account/Components/ui/Page/Page.Component'
import { CdkTableComponent } from '@ui/Components/Table/CdkTable.Component'

@Component({
	selector: 'addresses',
	templateUrl: './Addresses.Component.html',
	imports: [PageComponent, CdkTableComponent],
})
export class AddressesComponent extends Table<Address> implements OnInit {
	public displayColumns: string[] = ['line1', 'postcode', 'delete']

	private confirmDeleteDialogComponentMatDialogRef: MatDialogRef<ConfirmDeleteDialogComponent>

	private readonly addressService: AddressService

	private readonly dialog: MatDialog

	constructor() {
		super()
		this.addressService = inject(AddressService)
		this.dialog = inject(MatDialog)
	}

	public ngOnInit() {
		this.addressService.clearLocalStorageKey().resetFilter()

		this.addressService.filterable.type = BILLING

		this.tableEntities = [
			{
				columnDef: 'line1',
				header: 'Line 1',
				accessorKey: 'address1',
			},
			{
				columnDef: 'postcode',
				header: 'Postcode',
				accessorKey: 'postcode',
			},
			{
				columnDef: 'delete',
				header: 'Delete',
				type: 'action',
				action: {
					color: 'warn',
					title: 'Delete',
					output: async (entity: Address) => {
						this.confirmDeleteDialogComponentMatDialogRef = this.dialog.open(
							ConfirmDeleteDialogComponent,
						)

						this.confirmDeleteDialogComponentMatDialogRef
							.afterClosed()
							.subscribe(async (confirm: boolean) => {
								if (confirm) {
									try {
										await this.addressService.deleteAddress(entity)

										await this.fetchAddresses()
									} catch (error) {
										if (!(error instanceof HttpError)) {
											throw error
										}
									}
								}
							})
					},
				},
			},
		]

		this.fetchAddresses()
	}

	private readonly fetchAddresses = async () => {
		try {
			const addresses = await this.addressService.filter()

			this.setTableData(addresses)
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
